var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTableView = function SvgTableView(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.5 2.001h-10m10 5h-10m10 5h-10M2.333 2.835a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTableView);
export default ForwardRef;